import actions from '~/store/modules/shared/classifieds/form/actions'
import getters from '~/store/modules/shared/classifieds/form/getters'
import mutations from '~/store/modules/shared/classifieds/form/mutations'
import state from '~/store/modules/shared/classifieds/form/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
